import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  applications: [],
  currentApplication: null,
  statistics: {
    total: 0,
    submitted: 0,
    underReview: 0,
    shortlisted: 0,
    interviewed: 0,
    rejected: 0
  },
  loading: false,
  error: null
};

const applicationSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    setApplications: (state, action) => {
      state.applications = action.payload;
      state.loading = false;
      state.error = null;
    },
    setCurrentApplication: (state, action) => {
      state.currentApplication = action.payload;
    },
    setStatistics: (state, action) => {
      state.statistics = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const {
  setApplications,
  setCurrentApplication,
  setStatistics,
  setLoading,
  setError,
  clearError
} = applicationSlice.actions;

export default applicationSlice.reducer;
